module.exports = __webpack_public_path__ + "static/media/colors.c5ecf64a.png";